
export default function SystemFlow() {
  const flowSteps = [
    {
      icon: "ri-shopping-cart-line",
      title: "仕入れデータ",
      desc: "商品情報を入力",
      color: "bg-amber-500"
    },
    {
      icon: "ri-file-list-3-line",
      title: "スプレッドシート",
      desc: "利益・可否を自動判定",
      color: "bg-primary"
    },
    {
      icon: "ri-database-2-line",
      title: "出品データ生成",
      desc: "CSV/APIで自動作成",
      color: "bg-emerald-500"
    },
    {
      icon: "ri-store-2-line",
      title: "モール反映",
      desc: "各ECサイトへ登録",
      color: "bg-rose-500"
    },
    {
      icon: "ri-refresh-line",
      title: "在庫同期",
      desc: "リアルタイム更新",
      color: "bg-violet-500"
    }
  ];

  return (
    <section className="py-14 md:py-20 bg-gradient-to-b from-primary/5 to-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900">
            データが<strong className="text-primary">"回る"</strong>仕組み
          </h2>
          <p className="text-sm md:text-xl text-gray-600 mt-3 md:mt-4">
            人の判断と自動処理を最適に組み合わせます
          </p>
        </div>
        
        {/* フロー図 */}
        <div className="bg-white rounded-2xl md:rounded-3xl shadow-xl p-5 md:p-12">
          {/* スマホ: 2列グリッド / PC: 横並び */}
          <div className="hidden lg:flex items-center justify-between gap-4">
            {flowSteps.map((step, index) => (
              <div key={index} className="flex items-center">
                <div className="flex flex-col items-center text-center w-40">
                  <div className={`${step.color} w-20 h-20 rounded-2xl flex items-center justify-center shadow-lg mb-4`}>
                    <i className={`${step.icon} text-white text-4xl`} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-1">
                    {step.title}
                  </h3>
                  <p className="text-sm text-gray-500">
                    {step.desc}
                  </p>
                </div>
                {index < flowSteps.length - 1 && (
                  <div className="flex items-center justify-center w-12 text-primary">
                    <i className="ri-arrow-right-line text-4xl" />
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* スマホ用: 2列グリッド */}
          <div className="lg:hidden grid grid-cols-2 gap-4">
            {flowSteps.map((step, index) => (
              <div 
                key={index} 
                className={`flex flex-col items-center text-center p-3 rounded-xl bg-gray-50 ${index === flowSteps.length - 1 ? 'col-span-2 max-w-[50%] mx-auto' : ''}`}
              >
                <div className={`${step.color} w-12 h-12 rounded-xl flex items-center justify-center shadow-lg mb-2`}>
                  <i className={`${step.icon} text-white text-xl`} />
                </div>
                <h3 className="text-xs font-bold text-gray-900 mb-0.5">
                  {step.title}
                </h3>
                <p className="text-[10px] text-gray-500 leading-tight">
                  {step.desc}
                </p>
              </div>
            ))}
          </div>
          
          {/* 循環の矢印 */}
          <div className="mt-6 md:mt-10 flex items-center justify-center">
            <div className="flex items-center gap-2 md:gap-3 bg-primary/10 px-4 md:px-6 py-2 md:py-3 rounded-full">
              <i className="ri-loop-left-line text-primary text-lg md:text-2xl" />
              <span className="text-sm md:text-lg font-bold text-primary">自動で循環</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
